var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"itemTable",attrs:{"auto-resize":"","highlight-hover-row":"","size":"small","data":_vm.tableData,"columns":_vm.tableColumns,"height":'300px'},scopedSlots:_vm._u([{key:"tskInfoNo",fn:function(ref){
var row = ref.row;
return [_c('div',[_vm._v(" "+_vm._s(row.tskInfoNo)+" "),_c('br'),_c('div',{staticStyle:{"width":"235px"}},[_c('TskText',{attrs:{"content":row.tskOverview}},[(row.tskOverview)?_c('el-link',{ref:'link',attrs:{"underline":false,"type":"primary"},on:{"click":function($event){return _vm.openEditPage({
                  pageType: 'detail',
                  params: { code: row.tskInfoCode },
                  query: { tskInfoNo: row.tskInfoNo },
                })}}},[_vm._v(" "+_vm._s(row.tskOverview)+" ")]):_vm._e()],1)],1)])]}},{key:"tskByName",fn:function(ref){
                var row = ref.row;
return [_c('div',[_c('div',[_vm._v(" "+_vm._s(row.tskByName)+" ")]),_c('el-tag',{attrs:{"size":"mini","type":row.tskStatus == 'N'
              ? 'info'
              : row.tskStatus == 'P'
              ? ''
              : row.tskStatus == 'U'
              ? 'warning'
              : row.tskStatus == 'C'
              ? 'success'
              : row.tskStatus == 'Y'
              ? 'success'
              : 'danger'}},[_vm._v(" "+_vm._s(row.v_tskStatus)+" ")])],1)]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data mt-2"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }